export default {
  selectedCropSeasons: [],
  cropSeasonStartDate: undefined,
  cropSeasonEndDate: undefined,
  selectedCropzones: [],
  selectedPlans: [],
  selectedProducts: [],
  initialSubmit: false
};
